import React, { Component } from 'react'
import { MDBContainer, MDBBtn, MDBModal, MDBModalBody, MDBModalHeader, MDBModalFooter, MDBRow, MDBCol,MDBTableBody,MDBTable, MDBTableHead } from 'mdbreact';
import Axios from 'axios'
import { api, URL } from '../../api';
import Swal from 'sweetalert2/dist/sweetalert2.js'

export default class Modeladdshortterm extends Component {
    constructor(props) {
              super(props);
      this.state = {
        modal: false,
        studentsearch:[],
        name:'',
        lname:'',
        datedb:'',
        Citizen_ID:'',

        Course_ID:'',
        nameshortterm:'',
        nameshorttermen:'',
        Credit:'',
        team:'',
        numch:'',
        numregis:'',
        TIMESTART:'',
        TIMEEND:'',
        UserUPDATE:'',
        Univ_ID:'1',
        Univ_NAME:'',
        Course_YEAR:'',
        Status_ONOFF:'1',
        Course_Name_TH:'',

        typegrade:'',
        sumch:'',

       
      }
          //this.handleChange = this.handleChange.bind(this);
          this.getstudent = this.getstudent.bind(this);
          this.handleChangename = this.handleChangename.bind(this);
          this.handleChangelname = this.handleChangelname.bind(this);
          this.handleChangedatedb = this.handleChangedatedb.bind(this);
          this.updatestudent = this.updatestudent.bind(this);

          this.handleChangenameshortterm = this.handleChangenameshortterm.bind(this);
          this.handleChangenameshorttermen = this.handleChangenameshorttermen.bind(this);
          this.handleChangteam = this.handleChangteam.bind(this);
          this.handleChangeCredit = this.handleChangeCredit.bind(this);
          this.handleChangech = this.handleChangech.bind(this);
          this.handleChangeregis = this.handleChangeregis.bind(this);
          this.handleChangeTIMESTART = this.handleChangeTIMESTART.bind(this);
          this.handleChangeEND = this.handleChangeEND.bind(this);
          this.handleChangetypegrade = this.handleChangetypegrade.bind(this);
        
          
    }


  toggle = () => {
    this.setState({
      modal: !this.state.modal
    });
    //this.getstudent()
   // this.props.getShortcourse()
  }

  handleChangename(event) {    this.setState({name: event.target.value});  }
  handleChangelname(event) {    this.setState({lname: event.target.value});  }
  handleChangedatedb(event) {    this.setState({datedb: event.target.value});  }
  handleChangenameshortterm(event) {    this.setState({nameshortterm: event.target.value});  }
  handleChangenameshorttermen(event) {    this.setState({nameshorttermen: event.target.value});  }
  handleChangteam(event) {    this.setState({team: event.target.value});  }
  handleChangeCredit(event) {    this.setState({Credit: event.target.value});  }
  handleChangech(event) {    this.setState({numch: event.target.value});  }
  handleChangeregis(event) {    this.setState({numregis: event.target.value});  }
  handleChangeTIMESTART(event) {    this.setState({TIMESTART: event.target.value});  }
  handleChangeEND(event) {    this.setState({TIMEEND: event.target.value});  }

   handleChangetypegrade(event) {    this.setState({typegrade: event.target.value});  }
  

  getstudent() {
    api.get('index/studentsearch/'+this.props.Studentcb_Citizen_ID,
           //  Axios.get(`https://mis.kpru.ac.th/api/EmployeeInOrg/000`,
        {headers: {
           // Authorization: 'Bearer ' + localStorage.getItem('myData')
        }
        })
           //  axios.defaults.headers.common['Authorization'] = `Bearer` + localStorage.getItem('myData') 
        .then(res => {
           //    console.log(res.data[0].id)
            console.log(res.data[0].Studentcb_NAME)
           //   console.log(ppp)
           //  const student = res.data.filter( ({ citizen_id }) => citizen_id.substring(0, 7) === this.state.major );
            const studentsearch = res.data;
              this.setState({ studentsearch });
              this.setState({   name:res.data[0].Studentcb_NAME,
                                lname:res.data[0].Studentcb_LASTNAME,
                                datedb:res.data[0].Studentcb_DB,
                                Citizen_ID:res.data[0].Studentcb_Citizen_ID
                         });
        })
  }




  updatestudent() {
                setTimeout(() => {

                    const datafrm = new FormData(); //สร้างฟอร์มสำหรับการส่งข้อมูล
                    datafrm.append("Course_ID", this.state.Course_ID);
                    datafrm.append("Course_YEAR", this.state.Course_YEAR);
                    datafrm.append("nameshortterm", this.state.nameshortterm);
                    datafrm.append("nameshorttermen", this.state.nameshorttermen);
                    datafrm.append("Credit", this.state.Credit);
                    datafrm.append("team", this.state.team);
                    datafrm.append("numch", this.state.numch);
                    datafrm.append("numregis", this.state.numregis);
                    datafrm.append("timestart", this.state.TIMESTART);
                    datafrm.append("timeend", this.state.TIMEEND);
                    datafrm.append("userupdate", this.state.UserUPDATE);
                    datafrm.append("Status_ONOFF", this.state.Status_ONOFF);
                    datafrm.append("Univ_id", this.state.Univ_ID);
                    datafrm.append("typegradeshort", this.state.typegrade);
                    
                Axios.post("https://mua.kpru.ac.th/FrontEnd_creditbank/index/AddShortcourse/",datafrm,{
                headers: {
                    'content-type': 'multipart/form-data'
                }
                })
                .then(res => {
                    if (res.status === 200) {
                    //  alert("บันทึกสำเร็จ")
                                Swal.fire({
                                    title: 'บันทึกข้อมูลสำเร็จ',
                                    icon: 'success',
                                    confirmButtonText: 'ตกลง',
                                }).then((result) => {
                                 this.toggle()
                               //  this.getstudent()
                             //  this.props.getShortcourse()
                                 this.props.getShortcourseforuser()
                                })
                            }
                    })
                }, 2000);
  }


  componentDidMount(){
    this.setState({ Course_ID:this.props.Course_ID})
    this.setState({ nameshortterm:this.props.Course_Name_TH})
    this.setState({ nameshorttermen:this.props.Course_Name_En})
    this.setState({ Credit:this.props.Course_Credit})
    this.setState({ numch:this.props.sumch})
    this.setState({ Univ_ID:localStorage.getItem('Univ_ID')})
    this.setState({ Univ_NAME:localStorage.getItem('Univ_NAME')})
    this.setState({ UserUPDATE:localStorage.getItem('Citizen_ID')})
    this.setState({ Course_YEAR:this.props.Course_YEAR})
     this.setState({ sumch:this.props.sumch})
   // this.setState({ Credit:this.props.Credit})



  }

  

    render() {



     
        return (
            <div>
                 <div  className='text-center'><MDBBtn onClick={this.toggle} color="info" className='text-center' >+ เพิ่มวิชาหลัก</MDBBtn></div>  
                 <MDBContainer>
                 

                    
                    <MDBModal isOpen={this.state.modal} toggle={this.toggle}>
                        <MDBModalHeader toggle={this.toggle}>เพิ่มวิชาหลัก(ที่สามารถเที่ยบโอนได้)</MDBModalHeader>
                        <MDBModalBody>
                       
                                <MDBRow>
                                <MDBCol sm="12">
                                <div className="form-group">
                                    <label htmlFor="example2">รหัสวิชาหลัก</label>
                                    <input type="text" id="example2" className="form-control form-control-md" placeholder="ระบุ รายละเอียด" value={this.props.Course_ID}  disabled />
                                </div>
                                <div className="form-group">
                                    <label htmlFor="example2">ปีวิชาหลัก</label>
                                    <input type="text" id="example2" className="form-control form-control-md" placeholder="ระบุ รายละเอียด" value={this.props.Course_YEAR}  disabled />
                                </div>
                               
                                <div className="form-group">
                                    <label htmlFor="example2">ชื่อหลักสูตรระยะสั้น ภาษาไทย</label>
                                    <input type="text" id="example2" className="form-control form-control-md" placeholder="ระบุ รายละเอียด" value={this.state.nameshortterm} onChange={this.handleChangenameshortterm} disabled/>
                                </div>
                                <div className="form-group">
                                    <label htmlFor="example2">ชื่อหลักสูตรระยะสั้น ภาษาอังกฤษ</label>
                                    <input type="text" id="example2" className="form-control form-control-md" placeholder="ระบุ รายละเอียด" value={this.state.nameshorttermen} onChange={this.handleChangenameshorttermen} disabled />
                                </div>
                                <div className="form-group">
                                    <label htmlFor="example2">จำนวนหน่วยกิต</label>
                                    <input type="text" id="example2" className="form-control form-control-md" placeholder="ระบุ รายละเอียด" value={this.state.Credit} onChange={this.handleChangeCredit} disabled />
                                </div>
                                <div>

                                <div className="form-group">
                                    <label htmlFor="example2">จำนวนชั่วโมง</label>
                                    <input type="text" id="example2" className="form-control form-control-md" placeholder="ระบุ รายละเอียด" value={this.state.numch} onChange={this.handleChangech} disabled />
                                </div>    

                                <div className="form-group">
                                 <label htmlFor="example2">เทอม</label>
                                <select className="browser-default custom-select"  onChange={this.handleChangteam.bind(this)}  icon="user" required >
                                    <option>-- เลือกเทอม --</option>
                                    <option value="3/2568">3/2568</option>
                                    <option value="2/2568">2/2568</option>
                                    <option value="1/2568">1/2568</option>
                                    <option value="3/2567">3/2567</option>
                                    <option value="2/2567">2/2567</option>
                                    <option value="1/2567">1/2567</option>
                                    <option value="2/2566">2/2566</option>
                                    <option value="1/2566">1/2566</option>
                                    <option value="2/2565">2/2565</option>
                                    <option value="1/2565">1/2565</option>
                                    <option value="2/2564">2/2564</option>
                                    <option value="1/2564">1/2564</option>
                                </select> <br/>
                                </div>

                                    <div className="form-group">
                                 <label htmlFor="example2">ประเภทการให้เกรด ตามหลักสูตรที่ผ่านอนุมัติจากสภามหาวิทยาลัย</label>
                                <select className="browser-default custom-select"  onChange={this.handleChangetypegrade.bind(this)}  icon="user" required >
                                    <option>-- เลือกประเภทการให้เกรด --</option>
                                    <option value="1">เกณฑ์การให้เกรดปกติ A-E</option>
                                    <option value="2">เกณฑ์การให้เกรด P/PD/F</option>
                                </select> <br/>
                                </div>

                                </div>
                               
                               
                                {/* <div className="form-group">
                                    <label htmlFor="example2">จำนวนที่รับ</label>
                                    <input type="text" id="example2" className="form-control form-control-md" placeholder="ระบุ รายละเอียด" value={this.state.numregis} onChange={this.handleChangeregis} />
                                </div> */}
                                {/* <div className="form-group">
                                    <label htmlFor="example2">วันที่ เปิดการสอน</label>
                                    <input type="date" id="example2" className="form-control form-control-md" onChange={this.handleChangeTIMESTART} required/>
                                </div> */}
                                {/* <div className="form-group">
                                    <label htmlFor="example2">วันที่ ปิดการสอน</label>
                                    <input type="date" id="example2" className="form-control form-control-md"  onChange={this.handleChangeEND} required/>
                                </div>
                                <div className="form-group">
                                    <label htmlFor="example2">มหาวิทยาลัย</label>
                                    <input type="text" id="example2" className="form-control form-control-md" placeholder="ระบุ รายละเอียด" value={this.state.Univ_NAME} disabled />
                                </div> */}
                                </MDBCol>
                                </MDBRow>

                        </MDBModalBody>
                        <MDBModalFooter>
                        <MDBBtn color="primary" onClick={this.updatestudent}>บันทึก</MDBBtn>
                        <MDBBtn color="secondary" onClick={this.toggle}>ปิด</MDBBtn>
                       
                        </MDBModalFooter>
                    </MDBModal>



                  





                 </MDBContainer>
            </div>
        )
    }
}
